/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
import { GraphQLAPI } from './GraphQLAPI';
export { GraphQLAuthError, GRAPHQL_AUTH_MODE } from './types';
export { GraphQLAPI, GraphQLAPIClass, graphqlOperation } from './GraphQLAPI';
export * from './types';
export default GraphQLAPI;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aws-amplify/api-graphql/lib-esm/index.js
// module id = 780
// module chunks = 0